/* @flow weak */
// File type constants
// e.g., `FileTypes.getType(file.getContentType()) === FileTypes.AUDIO`
export const AUDIO = 'AUDIO';
export const DEFAULT = 'DEFAULT';
export const IMAGE = 'IMAGE';
export const MSEXCEL = 'MSEXCEL';
export const MSPOWERPOINT = 'MSPOWERPOINT';
export const MSWORD = 'MSWORD';
export const PDF = 'PDF';
export const TEXT = 'TEXT';
export const VIDEO = 'VIDEO';

// Mapping from file type constant to glyph name in r101-glyphs
const GLYPH_NAME_MAP = {
  [AUDIO]: 'microphone',
  [DEFAULT]: 'paperclip',
  [IMAGE]: 'image',
  [MSEXCEL]: 'excel',
  [MSPOWERPOINT]: 'powerpoint',
  [MSWORD]: 'word',
  [PDF]: 'pdf',
  [TEXT]: 'text',
  [VIDEO]: 'video',
};

/**
 * Given the content type of a file, return the file type
 */
export function getType(contentType) {
  // If we didn't get a string, give up and return the default
  // This also handles cases where contentType is undefined or null
  if (typeof contentType !== 'string') {
    return DEFAULT;
  }

  switch (contentType) {
    case 'application/pdf':
      return PDF;
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
    case 'text/csv':
      return MSEXCEL;
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.template':
    case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.openxmlformats-officedocument.presentationml.slide':
      return MSPOWERPOINT;
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
      return MSWORD;
    case 'application/mp4':
      return VIDEO;
    default:
      if (contentType.startsWith('audio')) {
        return AUDIO;
      } else if (contentType.startsWith('image')) {
        return IMAGE;
      } else if (contentType.startsWith('text')) {
        return TEXT;
      } else if (contentType.startsWith('video')) {
        return VIDEO;
      }
  }
  return DEFAULT;
}

/**
 * Given the content type of a file, return the glyph name
 */
export function getGlyphName(contentType) {
  return GLYPH_NAME_MAP[getType(contentType)];
}
